import { matchPath } from 'react-router';

const chromeViewerRouteMatches = (pathname, routeOwnerId) => {
  if (typeof pathname !== 'string' || typeof routeOwnerId !== 'string') return false;

  const match = matchPath(pathname, {
    path: '/app/chrome/view/:id',
    exact: true,
    strict: false,
  });

  return match?.params?.id === routeOwnerId;
};

const ownershipTupleMatches = (left, right) => (
  left?.attemptToken === right?.attemptToken
  && left?.routeOwnerId === right?.routeOwnerId
  && left?.routeGeneration === right?.routeGeneration
);

const tokenizedOwnershipMatches = (request, ownership) => (
  request?.mode === 'tokenized'
  && ownershipTupleMatches(request, ownership)
);

const requestOwnsRouteGeneration = (request, routeOwnerId, routeGeneration) => (
  request?.mode === 'tokenized'
  && request.routeOwnerId === routeOwnerId
  && request.routeGeneration === routeGeneration
);

export {
  chromeViewerRouteMatches,
  ownershipTupleMatches,
  requestOwnsRouteGeneration,
  tokenizedOwnershipMatches,
};
